import { render, staticRenderFns } from "./AuditoriasPagination.vue?vue&type=template&id=f3458294&"
import script from "./AuditoriasPagination.vue?vue&type=script&lang=js&"
export * from "./AuditoriasPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports